import { render, staticRenderFns } from "./distribute.vue?vue&type=template&id=8da27b60&"
import script from "./distribute.vue?vue&type=script&lang=js&"
export * from "./distribute.vue?vue&type=script&lang=js&"
import style0 from "./distribute.vue?vue&type=style&index=0&id=8da27b60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports